import { render, staticRenderFns } from "./TypeMatrixDialog.vue?vue&type=template&id=0ba1d76d&scoped=true"
import script from "./TypeMatrixDialog.vue?vue&type=script&lang=js"
export * from "./TypeMatrixDialog.vue?vue&type=script&lang=js"
import style0 from "./TypeMatrixDialog.vue?vue&type=style&index=0&id=0ba1d76d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba1d76d",
  null
  
)

export default component.exports